import { onActivated, onMounted, ref } from 'vue'
import router from '@/router'
import { ensureShokzRoutes } from '@/router/shokz-routes-register'
import { useShokzFeature } from '@/composables/useShokzFeature'

/**
 * 韶音 MDM 独立页面：租户校验 + 动态路由注册（不修改 routes.ts / guards.ts）
 */
export function useMdmShokzPage() {
  const pageReady = ref(false)
  const { isShokzTenant, loadShokzFeature } = useShokzFeature()

  const initPage = async () => {
    pageReady.value = false
    await loadShokzFeature(true)
    if (isShokzTenant.value) {
      ensureShokzRoutes(router)
    }
    pageReady.value = true
  }

  onMounted(() => {
    void initPage()
  })

  onActivated(() => {
    void initPage()
  })

  return {
    pageReady,
    isShokzTenant
  }
}
